import React from 'react'
import Page from '../components/sitemap'

function sitemap() {
  return (
    <div>
      <Page />
    </div>
  )
}

export default sitemap
